import Vue from 'vue';
import Component from 'vue-class-component';
import Moment from 'moment';

import { Status } from '@/models/status.model';
import { CourseService } from '@/courses/services/courses.service';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'ed-content-subject-calendar',
  components: {
    EdSubjectCalendar: () => import(/* EdSubjectCalendar */'@/courses/components/ed-subject-builder/ed-subject-calendar/ed-subject-calendar.component.vue')
  }
})
export default class EdContentSubjectCalendarComponent extends Vue {
  @Prop() readonly courseId: number;

  status: Status = new Status();
  calendarInfo: any = {};

  get lessons(): any[] {
    return this.calendarInfo.lessons || [];
  }

  get specialDays(): any[] {
    return  this.calendarInfo.specialDays || [];
  }

  get workingDays(): any[] {
    return  this.calendarInfo.workingDays || [];
  }

  get schoolDay() {
    return this.calendarInfo.schoolDay || {};
  }

  get startDateCalendar(): string {
    let date = this.schoolDay?.startDate;

    return date?.substring(0, date.length - 2)+'01';
  }

  get endDateCalendar(): string {
    let date = this.schoolDay?.endDate;
    let endOfMonth = Moment(date).clone().endOf('month').format('DD').toString();

    return date?.substring(0, date.length - 2)+endOfMonth;
  }

  async getSubjectCalendar() {
    try {
      this.status.setLoading();
      this.calendarInfo = await CourseService.getSubjectCalendar(this.courseId);
      this.status.setLoad();
    } catch(err) {
      this.status.setError();
    }
  }

  created() {
    this.getSubjectCalendar();
  }
}